export default __webpack_public_path__ + "static/media/raki_detail3.5a2ac263.jpg";